<template>
  <TransitionRoot as="template" :show="show">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="closeModal">
      <div class="flex items-end justify-center min-h-screen text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full modal">   
              <div class="flex justify-end px-2 pt-5">
                <button class="hover:text-white hover:bg-gray-200 text-black w-8 h-8 flex items-center justify-center w rounded-full" @click="closeModal()" >
                    <FontAwesomeIcon :icon="faTimes" class="block"/>        
                </button>
              </div>
           <div class=" px-10 pb-10 ">
            <h1 class="font-bold text-2xl px-5"> {{modalTranslation[language].translations.title}}  </h1>
            <div class=" pt-5 flex justify-between currency-container">
             <div class=" w-3/5 px-5" v-if="subscription">
                <h2> 
                    <FontAwesomeIcon :icon="faDollarSign" class="mr-2"/>  {{modalTranslation[language].translations.currency}} 
                </h2>
                <button class="btn-item ali" @click="onSelect('currency', 'MXN')" :class="{ 'selected' : setupTranslation.currency == 'MXN' || subscription.subscription.currentAmount.currencyCode  == 'MXN' }" v-if="subscription.subscription.currentAmount.currencyCode == 'MXN'"> 
                    <span> {{modalTranslation[language].translations.mxn}} </span>
                    <span> MXN </span> 
                </button>
                <button class="btn-item"  @click="onSelect('currency', 'USD')" :class="{ 'selected' : setupTranslation.currency == 'USD' || subscription.subscription.currentAmount.currencyCode  == 'USD' }" v-if="subscription.subscription.currentAmount.currencyCode == 'USD'"> 
                    <span> {{modalTranslation[language].translations.dollar}} </span>
                    <span> USD </span> 
                </button>
             </div>
              <div class=" w-3/5 px-5" v-else>
                <h2> 
                    <FontAwesomeIcon :icon="faDollarSign" class="mr-2"/>  {{modalTranslation[language].translations.currency}} 
                </h2>
                {{subscription}}
                <button class="btn-item ali" @click="onSelect('currency', 'MXN')" :class="{ 'selected' : setupTranslation.currency == 'MXN' }"> 
                    <span> {{modalTranslation[language].translations.mxn}} </span>
                    <span> MXN </span> 
                </button>
                <button class="btn-item"  @click="onSelect('currency', 'USD')" :class="{ 'selected' : setupTranslation.currency == 'USD' }"> 
                    <span> {{modalTranslation[language].translations.dollar}} </span>
                    <span> USD </span> 
                </button>
             </div>
             <div class=" w-2/5  pl-7 px-5 border-l border-gray-200">
                <h2> <FontAwesomeIcon :icon="faLanguage"  class="mr-2"/> {{modalTranslation[language].translations.language}}  </h2>
                 <button class="btn-item translation"  @click="onSelect('language', 'es')"  :class="{ 'selected' : setupTranslation.language == 'es' }" > 
                    <span> {{modalTranslation[language].translations.es}}  </span>
                    <span> <img :src="imgMX" alt=""> </span> 
                </button>
                  <button class="btn-item translation" @click="onSelect('language', 'eng')" :class="{ 'selected' : setupTranslation.language == 'eng' }"> 
                    <span> {{modalTranslation[language].translations.eng}} </span>
                    <span> <img :src="imgUS" alt=""> </span> 
                </button>
             </div>
             </div>
           </div>
           <div class="flex justify-end px-10 mb-10">
               <button class="w-full inline-flex justify-center rounded-md shadow-sm px-8 py-3 mt-4 border-2 bg-green-150 border-green-150 text-white font-medium hover:bg-green-200 focus:outline-none focus:ring-green-400  sm:w-auto hover:text-white" @click="onSave()">
                   {{modalTranslation[language].translations.buttonText}}
               </button>
           </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogOverlay, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faDollarSign, faLanguage, faTimes} from '@fortawesome/free-solid-svg-icons'
import { modalTranslation } from '@/translations/Modals.js'

import imgUS from "@/assets/img/icons/en-us.svg"
import imgMX  from "@/assets/img/icons/es-mx.svg"
import { computed, ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import { onMounted } from '@vue/runtime-core'
import { useRoute, useRouter } from 'vue-router'

export default {
  props: ['show'],
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    FontAwesomeIcon,
  },
  setup(props, context ){
        
        const language = computed(() => {
            return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
        })
        const router = useRouter()
        const route = useRoute()
        const store = useStore()
        const currency = computed(() => {
            return  localStorage.getItem('viva-currency') ? localStorage.getItem('viva-currency') : 'MXN';
        })

        const setupTranslation = ref({
            language: language.value,
            currency : currency.value,
            languageImage : language.value == 'es' ? imgMX : imgUS
        })

        const subscription = computed(() => {
            return store.state.Checkout.data.userSubscription.data
        })

        const setTranslate = ( lang ) => {
            localStorage.setItem('viva-translate',lang )
        }

        const setCurrency = ( currency ) => {
            localStorage.setItem('viva-currency', currency )
        }

        const onSelect = ( key, value ) => {
            setupTranslation.value[key] = value

            console.log( setupTranslation.value )
        }
        const onReload = () => {
            if( route.name != 'HomeViva'){
                router.push({ name : 'HomeViva'})
            } else{
                location.reload()
            }
        }

        const onSave = () => {
            setTranslate( setupTranslation.value.language  )
            setCurrency( setupTranslation.value.currency )
            onReload()
        }

        const closeModal  = ( ) => {
            context.emit('close')
            setTimeout( () => {
                setupTranslation.value = {
                    language: language.value,
                    currency : currency.value,
                    languageImage : language.value == 'es' ? imgMX : imgUS
                }
            }, 1000 )
        
        }
        onMounted(() => {
            if( subscription.value){
                localStorage.setItem('viva-currency',subscription.value.subscription.currentAmount.currencyCode )
            }
        })

      return {  faDollarSign, faLanguage, imgMX, imgUS, setupTranslation, faTimes, subscription , modalTranslation, language,  onSave, onSelect, closeModal,  }
  },
}
</script>
<style scoped>
h2{
    @apply font-bold text-lg block w-full mb-5 flex items-center align-middle;
}
.btn-item {
    @apply text-sm my-3 flex justify-between w-8/12 relative align-middle items-center;
}
.btn-item.translation {
    @apply w-full ;
}
.btn-item span:first-child{
    @apply font-semibold;
}

.btn-item:hover span:first-child{
    @apply text-red-200
}
.btn-item span:nth-child(2){
    @apply font-semibold text-gray-250 text-xs text-left;
    min-width: 40px;
}
.btn-item.selected span:first-child{
    @apply text-red-200;
}
.btn-item.selected::before{
    content: "";
    width:6px;
    height: 6px;
    left: -16px;
    top:7px;
    @apply absolute bg-red-200 rounded;
}

.btn-item span img{
    @apply w-5 h-5;
}
.modal{
   width:880px !important;

}
</style>